module.exports = __webpack_public_path__ + "img/n-4.57972fa0.png";